import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=954a494c&scoped=true"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js"
import style0 from "./SettingsGeneral.vue?vue&type=style&index=0&id=954a494c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954a494c",
  null
  
)

export default component.exports